import { Component, EventEmitter, Output } from '@angular/core';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-storage-filters',
  templateUrl: './storage-filters.component.html',
  styleUrls: ['./storage-filters.component.scss']
})
export class StorageFiltersComponent {
  @Output() storageSizesToFilterBy: EventEmitter<number[]> = new EventEmitter();
  selectedStorageSizes: number[] = [];

  constructor(private analytics: AnalyticsService) { }

  onStorageSizeFilterChange(sizes: number[]) {
    let indexOfStorageSize = 0;
    sizes.forEach(item => {
      indexOfStorageSize = this.selectedStorageSizes.indexOf(item);
      indexOfStorageSize < 0 ? this.selectedStorageSizes.push(item) : this.selectedStorageSizes.splice(indexOfStorageSize, 1);
    });
    this.storageSizesToFilterBy.emit(this.selectedStorageSizes);
    this.analytics.logCheckboxFilterClick(AnalyticsUtility.filterType.storage, sizes, indexOfStorageSize < 0);
  }
}
